__turbopack_context__.v({
  "location": "Location-module-scss-module__KXLQtq__location",
  "title": "Location-module-scss-module__KXLQtq__title",
});
